module.exports = __webpack_public_path__ + "img/c.d1a8480f.jpg";